<template>

  <div
      class="text-center"
      v-if="busy"
  >
    <v-progress-circular indeterminate />
  </div>

  <template v-if="!busy">
    <slot></slot>
  </template>

</template>

<script setup lang="ts">

defineProps({
  busy: {
    type: Boolean,
    required: true,
  },
})

</script>
